export default "__VITE_ASSET__BLK7uDUW__"